export class ApiUrl {
  //BaseUrl: string = "http://localhost/happyfleetrp_api/index.php";
  BaseUrl: string = "https://rp-api.happyfleets.com/index.php";
  //BaseUrl: string = "http://test-api.happyfleets.com/index.php";
}
